import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import SearchResult from '../SearchResult'

export const Container = styled.div`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${pxToRem(56)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(80)};
    max-width: calc(100% / 3 * 2);
    margin-inline-start: auto;
  }
`
export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.m375_h3}
  padding-block-end: ${pxToRem(24)};
  border-block-end: 1px solid rgba(0, 0, 0, 0.5);
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.d1440_h3}
    padding-block-end: ${pxToRem(40)};
    border-block-end: 1px solid rgba(0, 0, 0, 0.5);
  }
`
export const Category = styled.section`
  display: flex;
  flex-flow: column nowrap;
  gap: ${pxToRem(32)};
`
export const SubTitle = styled.h3`
  ${({ theme }) => theme.textStyles.m375_h2}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
  }
`
export const Results = styled.div``
export const _SearchResult = styled(SearchResult)`
  padding-block: ${pxToRem(16)};
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);
  &:last-child {
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  }
  @media ${mq(sizes.desktop)} {
    padding-block: ${pxToRem(24)};
  }
`
